import {
  GET_PROJECT_ACTIVITY_REQUEST,
  GET_PROJECT_ACTIVITY_ERROR,
  GET_PROJECT_ACTIVITY_SUCCESS,
  TOKEN_EXPIRED
} from '../types';
import context from "../common/getEntity"
import RESOURCES from '../../api/resources';

const initialState = {};
export default (selectQuery, filterQuery) => (state = initialState, action) => {

  context.init(context);

  context.GET_ENTITY_REQUEST = GET_PROJECT_ACTIVITY_REQUEST;
  context.GET_ENTITY_ERROR = GET_PROJECT_ACTIVITY_ERROR;
  context.GET_ENTITY_SUCCESS = GET_PROJECT_ACTIVITY_SUCCESS;
  context.TOKEN_EXPIRED = TOKEN_EXPIRED;

  context.entityName = "projectActivity";
  context.entityLocation = RESOURCES.ProjectActivities;
  context.selectQuery = "ID,Name,TenderPosition,Address,LocationPlusCode,Location,SortOrder";
  context.orderByQuery = "SortOrder, ID";

  if (selectQuery !== undefined && selectQuery !== null)
    context.selectQuery = selectQuery;

  if (filterQuery !== undefined && filterQuery !== null)
    context.filterQuery = filterQuery;

  return context.execute(context)()(state, action);
};